export default "__VITE_PUBLIC_ASSET__635a2bda__"